import { ReactComponent as PUZZLE } from "../../assets/Puzzle.svg"


export default function ComingSoon() {
  return (
    <div className={`w-full h-full flex justify-center flex-col items-center`}>
        <PUZZLE className="w-16 h-16"/>
        <p className="text-lg uppercase tracking-wider font-semibold leading-5 pt-1">Coming Soon</p>
        <div className="w-48 border-b-2 border-primary my-4" />
        <p className="text-sm w-96 text-center text-gray-300">Die Funktionen dieser Seite sind noch nicht für Sie verfügbar. Wir arbeiten daran, sie schnellstmöglich für alle freizuschalten. Sollten Sie die Funktionen in Ihrem Profil aktiviert haben, können Sie diese bald Seite nutzen.</p>
    </div>
)
}
